var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pw-tooltip",class:`pw-tooltip--${_vm.type} pw-tooltip--${_vm.align}`},[_c('span',{staticClass:"pw-tooltip__slot"},[_vm._t("default",function(){return [_c('i',{staticClass:"mdi",class:_vm.icon})]})],2),_c('span',{staticClass:"pw-tooltip__text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }